export default {
  'td.nav.glance': 'At a glance',
  'td.nav.route': 'Route',
  'td.nav.about': 'About this trip',
  'td.nav.iti': 'Day by day',
  'td.nav.inex': 'Included',
  'td.nav.rv': 'Reviews',
  'td.nav.fit': 'Right for you?',
  'td.nav.faq': 'FAQ',
  'td.notFound': 'Tour not found',
  'td.backHome': 'Back to Homepage',
  'td.realJourney': 'This journey is real. Yours will be your own version of it.',
  'td.glanceSub': '· this journey as it runs',
  'td.glance.duration': 'Duration',
  'td.glance.destinations': 'Destinations',
  'td.glance.tourPace': 'Tour pace',
  'td.glance.physicalRating': 'Physical rating',
  'td.glance.gettingAround': 'Getting around',
  'td.glance.bestSeason': 'Best season',
  'td.glance.indicativeFrom': 'Indicative from',
  'td.glance.departsAnyDay': 'Departs any day, year round',
  'td.glance.halong': 'Ha Long',
  'td.glance.overland': 'Can be reworked overland if you would rather not fly',
  'td.licensed': 'Licensed international tour operator',
  'td.route': 'Route',
  'td.about': 'About this trip',
  'td.includes': 'What this journey includes',
  'td.included': 'Included',
  'td.excluded': 'Excluded',
  'td.includesNote': 'This covers the journey as written above. Once your version is set, your local expert confirms in writing exactly what sits inside your quote and what does not, before anything is agreed.',
  'td.reviewsTitle': 'What our guests say',
  'td.excellent': 'Excellent on Tripadvisor',
  'td.verifiedReviews': 'Verified reviews from Meetup Travel guests',
  'td.readAllReviews': 'Read all reviews',
  'td.showLess': 'Show less',
  'td.readMore': 'Read more',
  'td.postedOn': 'Posted on',
  'td.prevReview': 'Previous review',
  'td.nextReview': 'Next review',
  'td.rightForYou': 'Is this journey a good starting point for you?',
  'td.honestVersion': 'The honest version',
  'td.goodIf': 'A good starting point if you are',
  'td.notIf': 'Say so early if you',
  'td.nextStepBold': 'The next step asks for real detail.',
  'td.nextStepRest': 'Your dates, who is travelling, how you like to move, what you would change about this route. It takes a few minutes to fill in, because a local expert writes your itinerary from those answers rather than sending you a file. Nothing is booked or charged at this stage.',
  'td.contactExpert': 'Contact a local expert',
  'td.beforeContact': 'Before you get in touch',
  'td.related': 'You might like these packages',
  'td.viewAll': 'View all →',
  'td.from': 'From',
  'td.view': 'View',
  'td.on': 'on',
  'td.rel1.title': 'Vietnam Family Tour - 15 Days',
  'td.rel1.duration': '15D14N',
  'td.rel2.title': 'Vietnam Honeymoon Journey',
  'td.rel2.duration': '10D9N',
  'td.rel3.title': 'North & Central Vietnam - 6 Days',
  'td.rel3.duration': '6D5N',
  'td.rel4.title': 'North to South Vietnam - 6 Days',
  'td.rel4.duration': '6D5N',
  'td.spots': '{{count}} Spots',
  'td.license': 'International travel licence',
  'td.payments': 'Visa · Mastercard · JCB · Amex · PayPal',
  'td.option3desc': 'This journey, 1 adult, 3-Star',
  'td.option3info': 'Comfortable 3-star hotels and a standard Halong Bay cruise. Clean rooms, friendly service and great value for a relaxed one-day trip.',
  'td.option4desc': 'This journey, 1 adult, 4-Star',
  'td.option4info': 'Upscale 4-star hotels and a more spacious cruise with better onboard dining and attentive service.',
  'td.option5desc': 'This journey, 1 adult, 5-Star',
  'td.option5info': 'Luxury 5-star hotels and a premium cruise with fine dining, spacious cabins and top-tier service.',
  'td.pricing.from': 'This journey, from',
  'td.pricing.perPerson': '{{currency}} / person',
  'td.pricing.planner': 'Travel Budget Planner',
  'td.pricing.yourOption': 'Your option',
  'td.pricing.adults': 'Number of Adult',
  'td.pricing.children': 'Number of Child',
  'td.pricing.decreaseAdult': 'Decrease adult',
  'td.pricing.increaseAdult': 'Increase adult',
  'td.pricing.decreaseChild': 'Decrease child',
  'td.pricing.increaseChild': 'Increase child',
  'td.pricing.roughTotal': 'Rough total, guide only',
  'td.pricing.noticeTitle': 'Important notice',
  'td.pricing.notice1a': 'This is the price for the journey as written',
  'td.pricing.notice1b': ', not a quote for your trip.',
  'td.pricing.notice2a': 'A local expert customises the detail with you.',
  'td.pricing.notice2b': ' Hotels, cruise, pace and inclusions are decided in that conversation, and the final price follows from it.',
  'td.pricing.notice3': 'Rates move with the season, with availability and with how far ahead you travel. Treat the number above as a guide.',
  'td.pricing.notice4': 'Child pricing depends on age and height and is confirmed case by case.',
  'td.pricing.bookingNow': 'Booking Now',
  'td.pricing.removeSaved': 'Remove from saved tours',
  'td.pricing.saveTour': 'Save tour',
  'td.pricing.noCharge': 'Nothing is booked or charged on this page',
  'td.pricing.cancellation': 'Cancellation policy',
  'td.pricing.flightTitle': 'Flight tickets & hotels / cruises',
  'td.pricing.flight1': 'Non-refundable',
  'td.pricing.flight2': 'Tickets can be kept on hold and rescheduled within 365 days',
  'td.pricing.flight3': 'Date changes subject to airline regulations and may incur additional fees',
  'td.pricing.flight4': "Hotel and cruise cancellations follow each property's own policy",
  'td.pricing.groupTitle': 'Group tours',
  'td.pricing.group1a': 'Free cancellation',
  'td.pricing.group1b': ' up to 2 days before departure',
  'td.pricing.group2a': '50% fee',
  'td.pricing.group2b': ' before 6:00 PM the day prior',
  'td.pricing.group3a': '100% fee',
  'td.pricing.group3b': ' after 6:00 PM the day prior',
  'td.pricing.privateTitle': 'Private tours',
  'td.pricing.private1a': 'Free cancellation',
  'td.pricing.private1b': ' up to 7 days before departure',
  'td.pricing.private2a': '50% fee',
  'td.pricing.private2b': ' within 4 to 7 days before departure',
  'td.pricing.private3a': '100% fee',
  'td.pricing.private3b': ' within 3 days of departure',
  'td.pricing.mobileJourney': 'this journey · {{label}}',
  'td.day.title': 'The journey, day by day',
  'td.day.collapse': 'Collapse all',
  'td.day.expand': 'Expand all',
  'td.day.intro': 'Written out the way it runs, so nothing is left to your imagination. Read it, note the days you would keep and the ones you would skip, and a local expert reshapes the rest around you.',
  'td.day.dayLabel': 'DAY {{n}}',
  'td.day.breakfast': 'Breakfast',
  'td.day.lunch': 'Lunch',
  'td.day.dinner': 'Dinner',
  'td.day.viewPhoto': 'View photo',
  'td.day.openPhotoFor': 'Open photo for {{title}}',
  'td.day.openPhoto': 'Open photo {{n}}',
  'td.day.close': 'Close',
  'td.day.previous': 'Previous',
  'td.day.next': 'Next',
  'td.breadcrumb': 'Breadcrumb',
  'td.pageSections': 'Page sections',
};